jQuery(document).ready(function($){
	initcarousel();
	initMobileNav();
	initDropDownClasses();
	initMobileMenu();
});

function initcarousel() {
	jQuery('.carousel').slick({
		arrows: true,
		autoplay: true,
		autoplaySpeed: 4000,
		infinite: true,
		speed: 500,
		fade: true,
		cssEase: 'linear',
		prevArrow: '<a href="#" class="slick-prev"></a>',
		nextArrow: '<a href="#" class="slick-next"></a>'
	});
}

// mobile menu init
function initMobileNav() {
	jQuery('body').mobileNav({
		hideOnClickOutside: true,
		menuActiveClass: 'nav-active',
		menuOpener: '.nav-opener',
		menuDrop: '.nav-wrap'
	});

	jQuery('.search-form').mobileNav({
		hideOnClickOutside: true,
		menuActiveClass: 'search-active',
		menuOpener: '.search-opener',
		menuDrop: '.search-drop'
	});
}

// add classes if item has dropdown
function initDropDownClasses() {
	jQuery('.nav li').each(function() {
		var item = jQuery(this);
		var drop = item.find('ul');
		var link = item.find('a').eq(0);
		if(drop.length) {
			item.addClass('has-dropdown');
			if(link.length) link.addClass('dropdown-a').before('<span class="opener"></span');
		}
	});
}

// mobile menu toggle
function initMobileMenu() {
	jQuery('.nav li').each(function(){
		var holder = jQuery(this),
			opener = holder.find('.opener');

		opener.click(function(){
			console.log('hellow');
			jQuery(this).parent().siblings().removeClass('drop-active')
			jQuery(this).parent().siblings().find('.dropdown').slideUp();
			jQuery(this).parent().toggleClass('drop-active');
			jQuery(this).parent().find('.dropdown').slideToggle();
			return false;
		});
	});
}